var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".spinner_Wezc{transform-origin:center;animation:spinner_Oiah .75s step-end infinite}@keyframes spinner_Oiah{8.3%{transform:rotate(30deg)}16.6%{transform:rotate(60deg)}25%{transform:rotate(90deg)}33.3%{transform:rotate(120deg)}41.6%{transform:rotate(150deg)}50%{transform:rotate(180deg)}58.3%{transform:rotate(210deg)}66.6%{transform:rotate(240deg)}75%{transform:rotate(270deg)}83.3%{transform:rotate(300deg)}91.6%{transform:rotate(330deg)}100%{transform:rotate(360deg)}}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "spinner_Wezc"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 2.5,
    r: 1.5,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.75,
    cy: 3.77,
    r: 1.5,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.23,
    cy: 7.25,
    r: 1.5,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 12,
    r: 1.5,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.23,
    cy: 16.75,
    r: 1.5,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.75,
    cy: 20.23,
    r: 1.5,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 21.5,
    r: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.98bb64fc57f579f6a3a0c8ac451ce5b0.svg";
export { ForwardRef as ReactComponent };